import { useFormik } from "formik";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { updateConfig } from "../../../../store/slices/Reports/reportsSlice";
import { useGetOtherReportEmployeeTableDataQuery } from "../../../../store/queries/Reports";
import { useNavigate } from "react-router-dom";
import {
  startOfWeek,
  endOfWeek,
  subWeeks,
  startOfMonth,
  endOfMonth,
} from "date-fns";
import moment from "moment";
import { useMemo, useState } from "react";
import { toast } from "react-toastify";
import { subDays } from "date-fns";
import { createStaticRanges } from "react-date-range";
const useEmployeeReport = () => {
  let paginationOptions = [
    { label: "10 Per page", value: 10 },
    { label: "20 Per page", value: 20 },
    { label: "30 Per page", value: 30 },
  ];
  const [date, setDate] = useState({
    startDate: subDays(new Date(), 29),
    endDate: new Date(),
    key: "selection",
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const reportState = useSelector((state) => state.reports);
  const formik = useFormik({
    initialValues: {
      branch: "",
    },
  });
  const startDate = new Date(date.startDate).toISOString().split("T")[0];
  const endDate = new Date(date.endDate).toISOString().split("T")[0];
  const initialFormattedDate = [startDate, endDate];
  const [formattedDate, setFormattedDate] = useState(initialFormattedDate);

  const {
    data: employeeReportData = {},
    isFetching,
    isLoading,
  } = useGetOtherReportEmployeeTableDataQuery({
    date: formattedDate,
    per_page: reportState?.otherReport?.currentPageSize,
    page: reportState?.otherReport?.currentPage,
    sort_by: reportState?.otherReport?.sortBy,
    sort_order: reportState?.otherReport?.sortOrder,
    search: reportState?.otherReport?.search,
    branch_id: formik?.values?.branch?._id,
  });

  const handleSearch = (e) => {
    dispatch(
      updateConfig((state) => {
        state.otherReport.search = e.target.value;
        state.otherReport.currentPage = 1;
      })
    );
  };

  const handlePageSize = ({ value: page_size }) => {
    dispatch(
      updateConfig((state) => {
        state.otherReport.currentPageSize = page_size;
        state.otherReport.currentPage = 1;
      })
    );
  };
  const handlePagination = (page) => {
    dispatch(
      updateConfig((state) => {
        state.otherReport.currentPage = page;
      })
    );
  };

  const handleSort = (label) => {
    if (reportState.otherReport.sortBy === label) {
      dispatch(
        updateConfig((state) => {
          state.otherReport.currentPage = 1;
          state.otherReport.sortOrder =
            reportState.otherReport.sortOrder === "asc" ? "desc" : "asc";
        })
      );
    } else {
      dispatch(
        updateConfig((state) => {
          state.otherReport.currentPage = 1;
          state.otherReport.sortBy = label;
          state.otherReport.sortOrder = "asc";
        })
      );
    }
  };

  const handleNameClick = (item) => {
    navigate({
      pathname: "/report/other/detail",
      search: `?id=${item?.user_id}&bid=${item?.branch_id}`,
    });
  };

  const tableFields = useMemo(() => {
    if (!employeeReportData?.data?.fields) return {};
    return {
      sl_no: { label: "Sl No" },
      ...employeeReportData.data.fields,
    };
  }, [employeeReportData?.data?.fields]);

  const tableData = useMemo(() => {
    if (!employeeReportData?.data?.data) return [];
    const currentPage = reportState?.otherReport?.currentPage || 1;
    const pageSize = reportState?.otherReport?.currentPageSize || 10;
    return employeeReportData.data.data.map((item, index) => ({
      ...item,
      sl_no: (currentPage - 1) * pageSize + index + 1,
    }));
  }, [
    employeeReportData?.data?.data,
    reportState?.otherReport?.currentPage,
    reportState?.otherReport?.currentPageSize,
  ]);

  const getRow = (field, data) => {
    const rows = {
      common: (field, data) => <p className="pro-mb-0">{data[field]}</p>,
      first_name: (field, data) => (
        <p className="pro-mb-0 pro-pnt" onClick={() => handleNameClick(data)}>
          {data[field]}
        </p>
      ),
    };
    return rows?.[field]?.(field, data) ?? rows["common"](field, data);
  };
    const handleDateChange = (date) => {
  
      const daysDiff = Math.ceil(date.endDate - date.startDate) / (1000 * 60 * 60 * 24);
  
      if (daysDiff > 29) {
        date.endDate = new Date(date.startDate.getTime() + 29 * 24 * 60 * 60 * 1000);
       toast.warn(
    "Maximum allowed range is 30 days. The selection has been adjusted automatically.",
    {
      style: {
        background: 'orange',
        color: 'black',
      },
    }
  );
        setTimeout(() => {
          document.querySelector('[title="Date range dropdown"]').click();
        }, 100);
      }
  
      const startDateUTC = new Date(date.startDate);
      const endDateUTC = new Date(date.endDate);
      const timeZoneOffset = 5.5 * 60 * 60 * 1000;
      const startDateIST = new Date(startDateUTC.getTime() + timeZoneOffset);
      const endDateIST = new Date(endDateUTC.getTime() + timeZoneOffset);
  
      const formatDate = (date) => {
        const year = date.getUTCFullYear();
        const month = String(date.getUTCMonth() + 1).padStart(2, "0");
        const day = String(date.getUTCDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      };
      const startDateFormatted = formatDate(startDateIST);
      const endDateFormatted = formatDate(endDateIST);
      const dateArray = [startDateFormatted, endDateFormatted];
      setFormattedDate(dateArray);
    };
   const customStaticRanges = createStaticRanges([
    {
      label: "Today",
      range: () => ({
        startDate: new Date(),
        endDate: new Date(),
      }),
    },
    {
      label: "Last 7 Days",
      range: () => {
        const now = new Date();
        const past = new Date();
        past.setDate(now.getDate() - 6); // Include today
        return {
          startDate: past,
          endDate: now,
        };
      },
    },
    {
      label: "This Week",
      range: () => {
        const now = new Date();
        return {
          startDate: startOfWeek(now, { weekStartsOn: 1 }), // Monday as start
          endDate: endOfWeek(now, { weekStartsOn: 1 }),
        };
      },
    },
    {
      label: "Last Week",
      range: () => {
        const now = new Date();
        const lastWeekStart = startOfWeek(subWeeks(now, 1), {
          weekStartsOn: 1,
        });
        const lastWeekEnd = endOfWeek(subWeeks(now, 1), {
          weekStartsOn: 1,
        });
        return {
          startDate: lastWeekStart,
          endDate: lastWeekEnd,
        };
      },
    },
    {
      label: "This Month",
      range: () => {
        const now = new Date();
        return {
          startDate: startOfMonth(now),
          endDate: endOfMonth(now),
        };
      },
    },
  ]);

  return {
    formik,
    isFetching,
    isLoading,
    reportState,
    employeeReportData,
    tableFields,
    tableData,
    paginationOptions,
    getRow,
    handleSort,
    handleSearch,
    handlePageSize,
    handlePagination,
    handleDateChange,
    customStaticRanges,
    date,
  };
};

export default useEmployeeReport;
